import { useTranslations } from '@power-core/toolkit';
import type { FunctionComponent } from 'react';
import { AbbDocument } from '@/assets/icons/components/abb-document';
import { useNavigation } from '@/modules/utils/custom-hooks/use-navigation';
import { useTheme } from '@/modules/utils/custom-hooks/use-theme';
import { Tooltip } from '@/ui-components/tooltip/tooltip';

type CardIconsProps = {
	isViewed: boolean;
	documentTypeId: string;
};

export const CardIcons: FunctionComponent<CardIconsProps> = ({ isViewed, documentTypeId }) => {
	const t = useTranslations();
	const { addSearchParam } = useNavigation();
	const { isDarkTheme } = useTheme();

	return (
		<Tooltip content={t('T_RELEASE_NOTES')}>
			<div className='relative'>
				{!isViewed && <span className='absolute bg-brand w-2 h-2 rounded-full right-0' />}
				<AbbDocument
					size={24}
					fill={isDarkTheme ? '#f1f1f1' : '#1f1f1f'}
					className='cursor-pointer'
					onClick={() =>
						addSearchParam([
							{ key: 'modal', value: 'ReleaseNotesModal' },
							{ key: 'id', value: documentTypeId },
							{ key: 'isViewedLastNote', value: String(isViewed) },
						])
					}
				/>
			</div>
		</Tooltip>
	);
};
